module.exports = __webpack_public_path__ + "static/img/14000092.6ad82a01.png";